<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      @for (owner of owners.controls; track owner; let index = $index) {
        <ng-container [formGroup]="owner">
          <div class="formControl mt">
            <ng-container formGroupName="riskProfil">
              <pr-input-radio
                formControlName="patrimonyValue"
                direction="column"
                [isDefault]="false"
                columns="2"
                [options]="options"
              >
              </pr-input-radio>
            </ng-container>
          </div>
          <div class="row">
            <div class="col col-md-12">
              <pr-input-column
                label="Précisez le montant exact"
                [derrors]="derrors"
                [isDefault]="false"
                [hidden]="
                  owner?.get('riskProfil')?.get('patrimonyValue').value !=
                  'GREATER_THAN_10M'
                "
              >
                <input notdot formControlName="montant" type="number" />
              </pr-input-column>
            </div>
          </div>
        </ng-container>
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
